import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SuccessModal from "./nodataFound/SuccessModal";
import useApi from "../customHook/useApi";
import { viewLeadProfile } from "../environment";

interface CityGuardProps {
  children: React.ReactNode;
}

type Profile = {
  leadId: string | null;
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: string | null;
  pref_locality_name: string | null;
  pref_locality_id: string | null;
};

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  message?: string;
}

const CityGuard: React.FC<CityGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // View Profile API CALL
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  // Determine selected city — prefer API over localStorage
  const selectedCity =
    profileData?.data?.pref_city_name || localStorage.getItem("selectedCity");

  useEffect(() => {
    if (!selectedCity) {
      setIsModalOpen(true);

      //   Auto-redirect after 2 seconds
      const timer = setTimeout(() => {
        setIsModalOpen(false);
        navigate("/onbording5");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [navigate]);

  return (
    <>
      {children}

      <SuccessModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          navigate("/onbording5");
        }}
        message="City Not Selected"
        subMessage="Please choose your preferred city to continue using the app."
        imgSrc={require("../assets/nestfin/map.png")}
      />
    </>
  );
};

export default CityGuard;
